var render = function render(){var _vm=this,_c=_vm._self._c;return _c('money',_vm._g(_vm._b({staticClass:"form-control",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'money',{ ..._vm.moneyConfig, ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }